module.exports = __webpack_public_path__ + "img/jqr2.5efc96d5.jpg";